// extracted by mini-css-extract-plugin
export default {"actions":"DeletePopup_actions__GRxXs"};